<div style="width:650px; margin:50px auto;">
  <button pButton type="button" class="p-button-rounded p-button-outlined"
          icon="pi pi-home" (click)="homePage()" [style]="{'display':'inline', 'margin-left': '0px'}"></button>
  <span style="font-size:20px;margin:10px;top:-8px;position:relative;">Sorry, this page doesn't exist!</span>
  <img src="assets/404.png" style="margin-top:10px" alt="Page Not Found">

</div>
